import Vue from 'vue';
import querystring from 'querystring';
import * as Articulos from '@lib/Articulos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher, SimpleEventDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

import * as Chats from '@/__env/lib/MercadoLibre/Chats';
import { Chat } from '@/__env/lib/MercadoLibre/Chats';
import { ControladorChatActivo } from './sala/controlador';
import { isArray, isObject } from 'util';

export class ControladorSeccion
{



    public readonly Buscador: Buscador = new Buscador();
    public Activo: ControladorChatActivo = null;
    protected seleccionado: Chat = null;
    public get Seleccionado() { return this.seleccionado; }
    public set Seleccionado( x: Chat )
    {
        this.seleccionado = x;
        if ( this.seleccionado )
        {
            Utiles.setQuery( { pack: this.Seleccionado.Pack } );
            this.Activo = new ControladorChatActivo( this.seleccionado );
        }
        this._onSeleccionados.dispatch();
    }

    async Iniciar()
    {
        this.IniciarSocket();
        await Wait( 100 );
    }

    public get Socket() { return Utiles.$socket.client; }
    public SocketIniciado: boolean = false;
    public SocketConectado: boolean = false;
    IniciarSocket()
    {

        if ( !this.SocketIniciado )
        {
            let self = this;
            this.Socket.on( 'XWML101', () =>
            {
                self.SocketConectado = true;
                console.log( 'chat conectado', self.SocketConectado );
            } );

            this.Socket.on( 'XWML300', ( x: any ) => this.NuevoChat( self, x ) );
            this.Socket.on( 'XWML301', ( x: any ) => this.NuevoMensaje( self, x ) );
            this.Socket.addEventListener( 'disconnect', () => this.Desconectado( self ) );
            this.Socket.addEventListener( 'reconnect', () => this.Reconectado( self ) );
        }

        console.log( 'iniciando socket' );
        this.Conectar();
        this.SocketIniciado = true;

    }
    public SocketCript( data: any ): Buffer
    {
        if ( !data )
            return Buffer.from( '' );

        let str: any = '';
        if ( isObject( data ) || isArray( data ) )
            str = JSON.stringify( data );
        else
            str = String( data );

        return Buffer.from( str, 'utf8' );
    }
    public SocketDecript( x: any, toObject: boolean = false ): string | any
    {
        if ( !toObject )
            return Buffer.from( x, 'utf8' ).toString();
        else
            return JSON.parse( Buffer.from( x, 'utf8' ).toString() );
    }

    Conectar()
    {
        this.Socket.emit( 'XWML100' );
    }

    Desconectado( self: ControladorSeccion )
    {
        console.log( 'disconnect' );
        this.SocketConectado = false;

    }

    Reconectado( self: ControladorSeccion )
    {
        console.log( 'reconnect' );
        this.Conectar();

    }


    NuevoChat( self: ControladorSeccion, x: any )
    {
        let m = self.SocketDecript( x, true );
        console.log( m );
    }

    async NuevoMensaje( self: ControladorSeccion, x: any )
    {
        let m = self.SocketDecript( x, true );
        console.log( m );

        if ( this.Activo && this.Activo.Chat.Id == m.chat )
        {
            this.Activo.AgregarMensaje( m );
        }

        let existe = this.Buscador.Items.find( x => x.Id == m.chat );
        if ( existe )
        {
            this.RecargarUltimoMensaje( m );
        } else
        {
            let chat = await Chat.create( parseInt( m.chat ) );
            if ( chat )
            {
                this.Buscador.Items.unshift( chat );
            }
        }

    }



    Abrir( x: Chat )
    {
        if ( x && x.Existe )
        {
            router.push( '/mercadolibre/publicacion/' + x.Id );
        }
    }

    CerrarChatActivo()
    {
        Utiles.setQuery( this.Buscador.Filtros.get() );
        this.Seleccionado = null;

    }

    public RecargarUltimoMensaje( mensaje: any )
    {
        this._onRecargarUltimoMensaje.dispatchAsync( mensaje );
    }

    private _onRecargarUltimoMensaje = new SimpleEventDispatcher<any>();
    public get onRecargarUltimoMensaje() { return this._onRecargarUltimoMensaje.asEvent(); }

    public Vista: Vista = new Vista();
    private _onSeleccionados = new SignalDispatcher();
    public get onSeleccionados() { return this._onSeleccionados.asEvent(); }

    public RecargarEstadistica()
    {
        this._onRecargarEstadistica.dispatch();
    }
    private _onRecargarEstadistica = new SignalDispatcher();
    public get onRecargarEstadistica() { return this._onRecargarEstadistica.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }

    public MenuOculto: boolean = false;
    public AlternarMenu()
    {
        this.MenuOculto = !this.MenuOculto;
    }

    public OcultarMenu()
    {
        this.MenuOculto = true;
    }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Items: Chat[] = [];

    public Filtros: Filtros = new Filtros( this );
    Iniciar()
    {
        this.Filtros = new Filtros( this );
    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null, agregar: boolean = false )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        if ( !agregar )
        {
            this.Items.clear();
            this.Estado = 'cargando';
        }

        Utiles.setQuery( this.Filtros.get() );
        this._onActualizar.dispatch();


        await Wait( 100 );
        let ff = this.Filtros.Obtener();
        //ff.limit = 20;
        //ff.plataforma = 'mercadopago';
        let e = await Chat.find( ff );
        if ( e.Error )
        {
            this.Estado = 'error';
        }
        else
        {
            if ( !agregar )
            {
                this.Items = e.Items;
            } else
            {
                this.Items.push( ...e.Items );
            }

            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, any> = {
        Cuenta: 0,
        Pagina: 1,
        Tag: 0,
        SoloLeidos: 0,
        SoloActivas: 0,
        Cliente: 0,
        Pack: 0,

    };


    //public get Estados() { return Chat.Estados.Filter; }
    //public get Tipos() { return [{ Nombre: 'Todos', Id: '' }, { Nombre: 'Ingreso', Id: 'N' }, { Nombre: 'Egreso', Id: 'S' }]; }
    //public get Metodos() { return Pagos.Tipos.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }

    public get Tags()
    {
        return [
            { Nombre: 'Todos', Id: '' },
            { Nombre: 'Error en codigo', Id: 'error_en_codigo', Valor: 'error_en_codigo' },
            { Nombre: 'Disponibles para reactivar', Id: 'disponible_para_reactivar', Valor: 'disponible_para_reactivar' },
            { Nombre: 'Faltante', Id: 'en_falta', Valor: 'en_falta' },
            { Nombre: 'Pausadas por faltante', Id: 'pausado_por_faltante', Valor: 'pausado_por_faltante' },
        ];
    }

    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {
        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {
            if ( this.Valores.Cuenta > 0 )
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }
        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};
        filtro.busqueda = 'S';
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
            if ( this.Valores.pagina != 1 )
            {
                this.Valores.pagina = 1;
            }
        }
        else
        {



            if ( this.Valores.Cliente > 0 )
            {
                filtro.cliente_id = this.Valores.Cliente;


            } if ( this.Valores.Pack > 0 )
            {
                filtro.pack = this.Valores.Pack;
            }


            if ( this.Valores.Cuenta > 0 )
            {
                filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
            }

            if ( this.Valores.SoloLeidos > 0 )
            {
                filtro.no_leidos = true;
            }

            if ( this.Valores.SoloActivas > 0 )
            {
                filtro.solo_activas = true;
            }

        }



        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }




        if ( filtro.cuenta )
        {
            this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }



        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Valores.SoloLeidos > 0 )
        {
            filtro.no_leidos = true;
        }

        if ( this.Valores.SoloActivas > 0 )
        {
            filtro.solo_activas = true;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

